/**
 * Set up routing for all Answer views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// import global components
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import sentiment answer views
import CreateSentimentAnswer from './views/CreateSentimentAnswer.js.jsx';
import SentimentAnswerList from './views/SentimentAnswerList.js.jsx';
import SingleSentimentAnswer from './views/SingleSentimentAnswer.js.jsx';
import UpdateSentimentAnswer from './views/UpdateSentimentAnswer.js.jsx';

class SentimentAnswerRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path="/admin/sentiment-answers" component={SentimentAnswerList} />
        <YTRoute login={true} exact path="/admin/sentiment-answers/new" component={CreateSentimentAnswer} />
        <Route exact path="/admin/sentiment-answers/:sentimentAnswerId" component={SingleSentimentAnswer}/>
        <YTRoute login={true} exact path="/admin/sentiment-answers/:sentimentAnswerId/update" component={UpdateSentimentAnswer}/>
      </Switch>
    )
  }
}

export default SentimentAnswerRouter;



// WEBPACK FOOTER //
// modules/sentimentAnswer/SentimentAnswerRouter.js.jsx